import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

export interface Page {
  number: number;
}

@Component({
  selector: 'md-paginator',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './paginator.component.html',
})
export class PaginatorComponent {
  // @ts-expect-error
  totalPages: number;
  // @ts-expect-error
  pages: Page[];

  @Output() newPage: EventEmitter<number> = new EventEmitter();

  @Input()
  set pageCount(p: number) {
    this.totalPages = p;
    this.pages = [];
    // eslint-disable-next-line functional/no-let
    for (let i = 1; i < this.totalPages + 1; i++) {
      this.pages.push({
        number: i,
      });
    }
  }
  // @ts-expect-error
  @Input() currentPage: number;

  handleClick(page: number) {
    this.newPage.emit(page);
  }

  nextPage() {
    const nextPage = this.currentPage + 1;
    if (nextPage <= this.totalPages) {
      this.newPage.emit(nextPage);
    }
  }

  prevPage() {
    const nextPage = this.currentPage - 1;
    if (nextPage > 0) {
      this.newPage.emit(nextPage);
    }
  }

  constructor() {}
}
